import React, { useState } from 'react';
import SettingRows from '../../../Elements/SettingRows';
import InlineSelect from '../../../Elements/InputComponents/BaseInputs/InlineSelect';

const runOptions = [
  { value: 'Daily', label: 'automatically, every morning' },
  { value: 'OnDemand', label: 'only when someone clicks Run Now' },
];

const monthOptions = [
  { value: 'DateDone', label: 'the shop was done' },
  { value: 'PrismRunStart', label: 'its Prism run started' },
];

function SettingRowsDemoComponent() {
  const [runs, setRuns] = useState('Daily');
  const [jobMonth, setJobMonth] = useState('DateDone');
  const rows = [
    {
      label: 'Runs',
      content: (
        <>
          Bravo prepares the draft invoices{' '}
          <InlineSelect
            value={runs}
            options={runOptions}
            label='Runs'
            onChange={setRuns}
          />
          .
        </>
      ),
    },
    {
      label: 'A job’s month',
      content: (
        <>
          A job goes on the draft of the month{' '}
          <InlineSelect
            value={jobMonth}
            options={monthOptions}
            label='A job belongs to the month'
            onChange={setJobMonth}
          />
          .
        </>
      ),
      note: 'A note under the sentence says what the choice means.',
    },
  ];

  return (
    <SettingRows rows={rows}>
      <span style={{ fontSize: 12.5, color: 'var(--ink-2)' }}>
        The foot, under the dashed line: what these settings do over a month, for example.
      </span>
    </SettingRows>
  );
}

export const settingRowsDemo = {
  id: 'setting-rows',
  title: 'Setting rows',
  category: 'Inputs',
  importPath: 'Elements/SettingRows',
  notes: [
    'Settings written as sentences, in a card: a small capitals label on the left, the sentence on the right with its choices inline (InlineSelect).',
    'rows are { label, content, note }; the note is a small line under the sentence. children go in the card’s foot, under a dashed line.',
    'First used by the automatic invoicing setup of a third-party project.',
  ],
  snippet:
    '<SettingRows\n  rows={[{ label: "Runs", content: <>Bravo prepares the draft invoices <InlineSelect ... />.</> }]}\n/>',
  render: SettingRowsDemoComponent,
};
